// import React, { useEffect } from 'react';
// import styles from './style.module.css';
// import Typography from '../../components/Typography/Typography';
// import { ModalClose, StoreCart, StoreImgName, StoreSearchIconDark } from '../../assets/svgs';
// import FlatButtons from '../../components/FlatButton/FlatButton';
// import { useSelector } from 'react-redux';
// import type { RootState } from '../../redux/store';

// interface StorePreviewModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     backgroundImage: string;
//     overlayImage?: string;
//     droppedProducts?: any[];
//     products?: any[];
//     storeName?: string;
//     storeLogo?: string;
// }

// export const StorePreviewModal: React.FC<StorePreviewModalProps> = ({
//     isOpen,
//     onClose,
//     backgroundImage,
//     overlayImage,
//     droppedProducts = [],
//     products = [],
//     storeName,
//     storeLogo
// }) => {
//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth > 1024 && isOpen) {
//                 onClose();
//             }
//         };

//         window.addEventListener('resize', handleResize);
//         handleResize();

//         return () => {
//             window.removeEventListener('resize', handleResize);
//         };
//     }, [isOpen, onClose]);

//     useEffect(() => {
//         if (isOpen) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = 'unset';
//         }

//         return () => {
//             document.body.style.overflow = 'unset';
//         };
//     }, [isOpen]);

//     const reduxProducts = useSelector((state: RootState) => state.CreateProduct);

//     const getProductPosition = (position: string, index: number) => {
//         const positionMap: { [key: string]: { x: number, y: number } } = {
//             'A1': { x: 50, y: 80 },
//             'A2': { x: 50, y: 180 },
//             'B1': { x: 180, y: 80 },
//             'B2': { x: 180, y: 180 },
//             'C1': { x: 310, y: 80 },
//             'C2': { x: 310, y: 180 },
//         };
//         return positionMap[position] || { x: 50 + (index * 80), y: 120 };

//     };

//     if (!isOpen) return null;

//     return (
//         <div className={styles.modalOverlay} onClick={onClose}>
//             <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
//                 <div className={styles.modalHeader}>
//                     <FlatButtons className={styles.closeButton} onClick={onClose}>
//                         <img src={ModalClose} alt='Close icon' />
//                     </FlatButtons>
//                 </div>

//                 <div className={styles.storeContainer}>
//                     <div className={styles.topNav}>
//                         <FlatButtons className={styles.storeName}>

//                             {storeLogo ? (
//                                 <img
//                                     src={storeLogo}
//                                     alt="Store Logo"
//                                     className={styles.storeLogo}
//                                     onError={(e) => {
//                                         const target = e.target as HTMLImageElement;
//                                         target.style.display = 'none';
//                                     }}
//                                 />
//                             ) : (
//                                 <img
//                                     src={StoreImgName}
//                                     alt="Store Icon"
//                                     className={styles.icon}
//                                 />
//                             )}
//                             <Typography
//                                 variant='buttonText'
//                                 fontFamily='satoshi'
//                                 weight='regular'
//                                 size='base'
//                                 className={styles.storeNameText}>
//                                 {storeName}
//                             </Typography>
//                         </FlatButtons>
//                         <FlatButtons className={styles.navIcons}>
//                             <img
//                                 src={StoreSearchIconDark}
//                                 alt="Search Icon"
//                                 className={styles.icon}
//                             />
//                             <img
//                                 src={StoreCart}
//                                 alt="Cart Icon"
//                                 className={styles.icon}
//                             />
//                         </FlatButtons>
//                     </div>

//                     <div className={styles.storeLayout}>
//                         <img
//                             src={backgroundImage}
//                             alt="Store background"
//                             className={styles.backgroundImage}
//                             onError={(e) => {
//                                 const target = e.target as HTMLImageElement;
//                                 target.src = backgroundImage;
//                                 console.error('Failed to load background image:', backgroundImage);
//                             }}
//                         />

//                         {overlayImage && (
//                             <div className={styles.overlay}>
//                                 <img
//                                     src={overlayImage}
//                                     alt="Store overlay"
//                                     className={styles.overlayImage}
//                                     onError={(e) => {
//                                         const target = e.target as HTMLImageElement;
//                                         target.src = overlayImage;
//                                         console.error('Failed to load overlay image:', overlayImage);
//                                     }}
//                                 />
//                             </div>
//                         )}

//                         {reduxProducts && reduxProducts.length > 0 && reduxProducts.map((product, index) => {
//                             const position = getProductPosition(product.position_in_store, index);

//                             return (
//                                 <div
//                                     key={`store-product-${index}`}
//                                     className={styles.storeProduct}
//                                     style={{
//                                         left: `${position.x}px`,
//                                         top: `${position.y}px`,
//                                     }}
//                                 >
//                                     {product.image_file && (
//                                         <img
//                                             src={product.image_file}
//                                             alt={product.name}
//                                             className={styles.storeProductImage}
//                                             onError={(e) => {
//                                                 const target = e.target as HTMLImageElement;
//                                                 target.style.display = 'none';
//                                             }}
//                                         />
//                                     )}
//                                     <Typography
//                                         variant='bodySmall'
//                                         fontFamily='satoshi'
//                                         weight='bold'
//                                         className={styles.storeProductName}>
//                                         {product.name}
//                                     </Typography>
//                                 </div>
//                             );
//                         })}

//                         {droppedProducts && droppedProducts.length > 0 && (
//                             <div className={styles.productsContainer}>
//                                 {droppedProducts.map((product: any) => (
//                                     <div
//                                         key={product.dropId || product.id}
//                                         className={styles.droppedProduct}
//                                         style={{
//                                             left: `${product.x}px`,
//                                             top: `${product.y}px`
//                                         }}
//                                     >
//                                         <img
//                                             src={product.image_preview_url || product.image}
//                                             alt={product.name}
//                                             className={styles.droppedProductImage}
//                                         />
//                                     </div>
//                                 ))}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };






import React, { useEffect } from 'react';
import styles from './style.module.css';
import Typography from '../Typography/Typography';
import { ModalClose, StoreCart, StoreImgName, StoreSearchIconDark } from '../../assets/svgs';
import FlatButtons from '../FlatButton/FlatButton';

interface StorePreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    backgroundImage: string;
    overlayImage?: string;
    droppedProducts?: any[];
    products?: any[];
    storeName?: string;
    storeLogo?: string;
}

export const StorePreviewModal: React.FC<StorePreviewModalProps> = ({
    isOpen,
    onClose,
    backgroundImage,
    overlayImage,
    droppedProducts = [],
    products = [],
    storeName,
    storeLogo
}) => {
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1024 && isOpen) {
                onClose();
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    // Helper function for product positioning with responsive scaling
    const getProductPosition = (position: string, index: number) => {
        // Base positions for desktop/tablet
        const basePositions: { [key: string]: { x: number; y: number } } = {
            'A1': { x: 50, y: 80 },
            'A2': { x: 50, y: 180 },
            'B1': { x: 180, y: 80 },
            'B2': { x: 180, y: 180 },
            'C1': { x: 310, y: 80 },
            'C2': { x: 310, y: 180 },
        };

        // Get base position
        const basePos = basePositions[position] || { x: 50 + (index * 80), y: 120 };

        // Apply responsive scaling for mobile
        if (typeof window !== 'undefined') {
            const width = window.innerWidth;
            
            if (width <= 480) {
                // Mobile: scale down positions proportionally
                return {
                    x: basePos.x * 0.5, // Scale to 50%
                    y: basePos.y * 0.6  // Scale to 60%
                };
            } else if (width <= 768) {
                // Tablet: scale down slightly
                return {
                    x: basePos.x * 0.7,
                    y: basePos.y * 0.8
                };
            }
        }

        return basePos;
    };

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <FlatButtons className={styles.closeButton} onClick={onClose}>
                        <img src={ModalClose} alt='Close icon' />
                    </FlatButtons>
                </div>

                <div className={styles.storeContainer}>
                    <div className={styles.topNav}>
                        <FlatButtons className={styles.storeName}>
                            {storeLogo ? (
                                <img
                                    src={storeLogo}
                                    alt="Store Logo"
                                    className={styles.storeLogo}
                                    onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.style.display = 'none';
                                    }}
                                />
                            ) : (
                                <img
                                    src={StoreImgName}
                                    alt="Store Icon"
                                    className={styles.icon}
                                />
                            )}
                            <Typography
                                variant='buttonText'
                                fontFamily='satoshi'
                                weight='regular'
                                size='base'
                                className={styles.storeNameText}>
                                {storeName}
                            </Typography>
                        </FlatButtons>
                        <FlatButtons className={styles.navIcons}>
                            <img
                                src={StoreSearchIconDark}
                                alt="Search Icon"
                                className={styles.icon}
                            />
                            <img
                                src={StoreCart}
                                alt="Cart Icon"
                                className={styles.icon}
                            />
                        </FlatButtons>
                    </div>

                    <div className={styles.storeLayout}>
                        <img
                            src={backgroundImage}
                            alt="Store background"
                            className={styles.backgroundImage}
                            onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = backgroundImage;
                                console.error('Failed to load background image:', backgroundImage);
                            }}
                        />

                        {overlayImage && (
                            <div className={styles.overlay}>
                                <img
                                    src={overlayImage}
                                    alt="Store overlay"
                                    className={styles.overlayImage}
                                    onError={(e) => {
                                        const target = e.target as HTMLImageElement;
                                        target.src = overlayImage;
                                        console.error('Failed to load overlay image:', overlayImage);
                                    }}
                                />
                            </div>
                        )}

                        {/* Display store products from AddProducts page */}
                        {products && products.length > 0 && products.map((product: any, index: number) => {
                            const position = getProductPosition(product.position_in_store, index);
                            
                            return (
                                <div
                                    key={`store-product-${index}`}
                                    className={styles.storeProduct}
                                    style={{
                                        left: `${position.x}px`,
                                        top: `${position.y}px`,
                                    }}
                                >
                                    {product.image_file && (
                                        <img
                                            src={product.image_file}
                                            alt={product.name}
                                            className={styles.storeProductImage}
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.style.display = 'none';
                                            }}
                                        />
                                    )}
                                    <Typography
                                        variant='bodySmall'
                                        fontFamily='satoshi'
                                        weight='bold'
                                        className={styles.storeProductName}>
                                        {product.name}
                                    </Typography>
                                </div>
                            );
                        })}

                        {/* Display dropped props from CustomizeStore page */}
                        {droppedProducts && droppedProducts.length > 0 && (
                            <div className={styles.productsContainer}>
                                {droppedProducts.map((product: any) => (
                                    <div
                                        key={product.dropId || product.id}
                                        className={styles.droppedProduct}
                                        style={{
                                            left: `${product.x}px`,
                                            top: `${product.y}px`
                                        }}
                                    >
                                        <img
                                            src={product.image_preview_url || product.image}
                                            alt={product.name}
                                            className={styles.droppedProductImage}
                                        />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};